export default class KucHelper {
    static isKucReservation(reservationData) {
        return reservationData.kuc_order_id != null;
    }
}